export const insurerTable = [
  {
    name: "Policy #",
    accessor: "policy_number",
  },
  {
    name: "Insurer",
    accessor: "insurer_company_name",
  },
  {
    name: "Insured",
    accessor: "insured_by",
  },
  {
    name: "Renewal Status",
    accessor: "renewal_status",
  },
  {
    name: "Business Name",
    accessor: "business_name",
  },
  {
    name: "Business State",
    accessor: "business_state",
  },
  {
    name: "Currency",
    accessor: "currency",
  },
  {
    name: "Total Sum Insured",
    accessor: "sum_insured",
  },
  {
    name: "Fac. Sum Insured",
    accessor: "fac_sum_insured",
  },
  {
    name: "Fac. Premium",
    accessor: "fac_premium",
  },
  {
    name: "Brokerage",
    accessor: "brokerage_amount",
  },
  {
    name: "Outstanding Brokerage Amount",
    accessor: "outstanding_brokerage_amount",
  },
  {
    name: "Premium due KEK",
    accessor: "expected_amount",
  },
  {
    name: "Outstanding premium",

    accessor: "outstanding_amount",
  },
  {
    name: "Period of Insurance",
    accessor: "period",
  },
  {
    name: "Placed Share",
    accessor: "placed_offer",
  },
  {
    name: "Offer Status",
    accessor: "offer_status",
  },
  {
    name: "Payment Status",
    accessor: "payment_status",
  },
  {
    name: "Offer Date",
    accessor: "offer_date",
  },
  {
    name: "Closed Date",
    accessor: "closed_date",
  },
  {
    name: "END",
    accessor: "hasEndorsement",
  },
];

export const reinsurerTable = [
  {
    name: "Policy #",
    accessor: "policy_number",
  },
  {
    name: "Reinsurer",
    accessor: "re_company_name",
  },
  {
    name: "Renewal Status",
    accessor: "renewal_status",
  },
  {
    name: "Insured",
    accessor: "insured_by",
  },
  {
    name: "Business Name",
    accessor: "business_name",
  },
  {
    name: "Business State",
    accessor: "business_state",
  },
  {
    name: "Currency",
    accessor: "currency",
  },
  {
    name: "Total Sum Insured",
    accessor: "sum_insured",
  },
  {
    name: "Fac. Sum Insured",
    accessor: "fac_sum_insured",
  },
  {
    name: "Fac. Premium",
    accessor: "fac_premium",
  },
  {
    name: "Brokerage",
    accessor: "brokerage_amount",
  },
  {
    name: "Outstanding Brokerage Amount",
    accessor: "outstanding_brokerage_amount",
  },
  {
    name: "Premium due KEK",
    accessor: "expected_amount",
  },
  {
    name: "Outstanding premium",
    accessor: "outstanding_amount",
  },
  {
    name: "Period of Insurance",
    accessor: "period",
  },
  {
    name: "Placed Share",
    accessor: "placed_offer",
  },
  {
    name: "Offer Status",
    accessor: "offer_status",
  },
  {
    name: "Payment Status",
    accessor: "payment_status",
  },
  {
    name: "Offer Date",
    accessor: "created_at",
  },
  {
    name: "Closed Date",
    accessor: "closed_date",
  },
  {
    name: "END",
    accessor: "hasEndorsement",
  },
];

export const allTable = [
  {
    name: "Policy #",
    accessor: "policy_number",
  },
  {
    name: "Renewal Status",
    accessor: "renewal_status",
  },
  {
    name: "Insurer/Reinsurer",
    accessor: "re_company_name",
  },
  {
    name: "Insured",
    accessor: "insured_by",
  },
  {
    name: "Business Name",
    accessor: "business_name",
  },
  {
    name: "Business State",
    accessor: "business_state",
  },
  {
    name: "Currency",
    accessor: "currency",
  },
  {
    name: "Fac. Sum Insured",
    accessor: "fac_sum_insured",
  },
  {
    name: "Total Sum Insured",
    accessor: "sum_insured",
  },
  {
    name: "Fac. Premium",
    accessor: "fac_premium",
  },
  {
    name: "Brokerage",
    accessor: "brokerage_amount",
  },
  {
    name: "Outstanding Brokerage Amount",
    accessor: "outstanding_brokerage_amount",
  },
  {
    name: "Premium due KEK",
    accessor: "expected_amount",
  },
  {
    name: "Outstanding premium",
    accessor: "outstanding_amount",
  },
  {
    name: "Period of Insurance",
    accessor: "period",
  },
  {
    name: "Placed Share",
    accessor: "placed_offer",
  },
  {
    name: "Offer Status",
    accessor: "offer_status",
  },
  {
    name: "Payment Status",
    accessor: "payment_status",
  },
  {
    name: "Business State",
    accessor: "business_state",
  },
  {
    name: "Offer Date",
    accessor: "offer_date",
  },
  {
    name: "Closed Date",
    accessor: "closed_date",
  },
  {
    name: "END",
    accessor: "hasEndorsement",
  },
];
